import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const BRAND = { r: 10, g: 21, b: 38 }; // ink-900 Lovelia

async function loadImageDataUrl(url) {
  try {
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
}

// rows: tableau de [label, value] ; meta: libellés localisés + infos client
async function buildRecapDoc(rows, meta) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  // Bandeau en-tête aux couleurs de la marque
  doc.setFillColor(BRAND.r, BRAND.g, BRAND.b);
  doc.rect(0, 0, pageW, 92, 'F');

  let textX = 40;
  if (meta.logoUrl) {
    const logo = await loadImageDataUrl(meta.logoUrl);
    if (logo) {
      try {
        doc.setFillColor(255, 255, 255);
        doc.roundedRect(38, 18, 58, 58, 6, 6, 'F');
        doc.addImage(logo, 'JPEG', 42, 22, 50, 50);
        textX = 112;
      } catch (e) { /* logo optionnel */ }
    }
  }

  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(19);
  doc.text('LOVELIA', textX, 40);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('IMMOBILIER NEUF', textX, 57);
  doc.setFontSize(9);
  doc.text(meta.title, textX, 74);

  // Intro
  doc.setTextColor(70, 70, 70);
  doc.setFontSize(11);
  const introLines = doc.splitTextToSize(meta.intro, pageW - 80);
  doc.text(introLines, 40, 122);
  const startY = 122 + introLines.length * 14 + 8;

  autoTable(doc, {
    startY,
    head: [[meta.colField, meta.colValue]],
    body: rows.map(([l, v]) => [String(l), String(v)]),
    theme: 'grid',
    headStyles: { fillColor: [BRAND.r, BRAND.g, BRAND.b], textColor: 255, fontStyle: 'bold', fontSize: 10 },
    alternateRowStyles: { fillColor: [250, 245, 245] },
    styles: { fontSize: 10, cellPadding: 6, textColor: [40, 40, 40], lineColor: [230, 230, 230] },
    columnStyles: { 0: { cellWidth: 200, fontStyle: 'bold', textColor: [90, 90, 90] } },
    margin: { left: 40, right: 40 },
  });

  const finalY = (doc.lastAutoTable && doc.lastAutoTable.finalY) || startY;
  doc.setDrawColor(BRAND.r, BRAND.g, BRAND.b);
  doc.setLineWidth(1);
  const footY = Math.min(finalY + 28, pageH - 50);
  doc.line(40, footY, pageW - 40, footY);
  doc.setFontSize(9);
  doc.setTextColor(130, 130, 130);
  doc.text(meta.footer, 40, footY + 16);
  doc.text(new Date().toLocaleDateString('fr-FR'), pageW - 40, footY + 16, { align: 'right' });

  return doc;
}

export async function downloadRecapPdf(rows, meta) {
  const doc = await buildRecapDoc(rows, meta);
  doc.save(meta.filename);
}

// Retourne le PDF récapitulatif encodé en base64 (sans préfixe data URI), pour pièce jointe email
export async function buildRecapPdfBase64(rows, meta) {
  const doc = await buildRecapDoc(rows, meta);
  const uri = doc.output('datauristring');
  const idx = uri.indexOf('base64,');
  return idx >= 0 ? uri.slice(idx + 7) : '';
}
